import { render, staticRenderFns } from "./Identifier.vue?vue&type=template&id=8fc08054&scoped=true&lang=pug&"
import script from "./Identifier.vue?vue&type=script&lang=js&"
export * from "./Identifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc08054",
  null
  
)

export default component.exports